import './style.css';

export default class LazyImage {
    static selector = '.lazy';

    constructor(block) {
        this.block = block;
    }
}
